import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { ThunkMiddlewareFor } from '@reduxjs/toolkit/src/getDefaultMiddleware';
import { Action, AnyAction, Dispatch, Middleware, Reducer, ReducersMapObject } from 'redux';
import createSagaMiddleware, { Saga } from 'redux-saga';
import { WS_NAMESPACE } from 'domains/webSockets/WebSocket.types';

type Middlewares<S> = ReadonlyArray<Middleware<unknown, S>>;

export function buildStore<S = any, A extends Action = AnyAction, M extends Middlewares<S> = [ThunkMiddlewareFor<S>]>(
  reducers: Reducer<S, A> | ReducersMapObject<S, A>,
  sagas: Saga[],
  middleware?: M,
): EnhancedStore<S, A, Middleware<unknown, S, Dispatch<AnyAction>>[]> {
  const sagaMiddleware = createSagaMiddleware();
  const middlewareToAdd = middleware ? middleware.concat(sagaMiddleware) : [sagaMiddleware];

  const store = configureStore({
    reducer: reducers,
    middleware: middlewareToAdd,
    devTools: {
      actionsDenylist: [`${WS_NAMESPACE}/addRequest`, `${WS_NAMESPACE}/removeRequest`],
    },
  });

  sagas.forEach((saga: Saga) => sagaMiddleware.run(saga));
  return store;
}
